export default __webpack_public_path__ + "static/media/bedroom.50f8fb27.jpg";